import HTTP from '../http';

export interface FinanceExtractResponse {
  data: Record<string, unknown>[];
}

export const fetchFinanceExtract = (params: { lastId: number; size: number }) =>
  HTTP.get('/reports/finance-extract', { params });

export const downloadFinanceExtract = (params: { lastId?: number; size?: number } = {}) =>
  HTTP.get('/reports/finance-extract/csv', {
    params,
    responseType: 'blob',
    headers: { Accept: 'text/csv' },
  });
